import React from "react";

export const NotFound = () => <>{"Page not found"}</>;

// export default NotFound;
// export { NotFound };
